<p>
  @if (showExpandedText()) {
    {{ text() }}
  } @else {
    {{ trimmedText() }}...
  }

  @if (showExpandButton()) {
    @if (!showExpandedText()) {
      <a (click)="toggleExpanded()">{{ expandLabel() }}</a>
    } @else {
      <a (click)="toggleExpanded()">Schließen</a>
    }
  }
</p>
